<template>
  <head>
    <title>
      {{ $i18n.locale == "ar" ? data.name_ar : data.name_en }}
    </title>
    <meta
      name="description"
      :content="
        $i18n.locale === 'ar' ? data.description_ar : data.description_en
      "
    />
  </head>
  <div class="story-details">
    <NavbarComponent />
    <main id="main">
      <!-- ======= Breadcrumbs ======= -->
      <div
        class="breadcrumbs d-flex align-items-center"
        style="background-image: url('assets/img/ourservice.jpg')"
      >
        <div
          class="container position-relative d-flex flex-column align-items-center"
        >
          <h2>{{ $i18n.locale == "ar" ? data.name_ar : data.name_en }}</h2>
          <ol>
            <li>
              <a href="/">{{ $t("home") }}</a>
            </li>
            <li>{{ $i18n.locale == "ar" ? data.name_ar : data.name_en }}</li>
          </ol>
        </div>
      </div>
      <!-- End Breadcrumbs -->

      <!-- ======= Blog Details Section ======= -->
      <section id="stories" class="blog" v-if="data.length != 0">
        <div class="container" data-aos="fade-up">
          <div class="row g-5">
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="200">
              <article class="blog-details">
                <div class="post-img">
                  <img
                    :src="
                      $store.state.server +
                      ($i18n.locale == 'ar' ? data.img : data.img_en)
                    "
                    :alt="$i18n.locale == 'ar' ? data.name_ar : data.name_en"
                    class="img-fluid w-75"
                  />
                </div>

                <h2 class="title-blog">
                  {{ $i18n.locale == "ar" ? data.name_ar : data.name_en }}
                </h2>

                <div class="meta-top">
                  <ul>
                    <li class="d-flex align-items-center">
                      <i class="bi bi-clock"></i>
                      <a href="/" style="cursor: none; pointer-events: none"
                        ><time :datetime="data.date">{{
                          compressDate(data.date)
                        }}</time></a
                      >
                    </li>
                  </ul>
                </div>
                <!-- End meta top -->

                <div class="content">
                  <p>
                    {{
                      $i18n.locale == "ar"
                        ? data.description_ar
                        : data.description_en
                    }}
                  </p>
                  <p
                    class="title-route my-4"
                    v-if="
                      data.link != '' &&
                      data.link != null &&
                      data.link != 'NULL'
                    "
                  >
                    <a :href="data.link" target="_blank">{{
                      $i18n.locale == "ar"
                        ? "اضغط للذهاب إلى موقع الشركة"
                        : "Click to check the company website"
                    }}</a>
                  </p>
                  <!-- ======= Media Content ======= -->
                  <div class="media-content my-4">
                    <div
                      v-if="
                        data.video &&
                        data.video !== 'NULL' &&
                        data.video !== '' &&
                        data.video != null
                      "
                    >
                      <div class="ratio ratio-16x9">
                        <iframe
                          width="560"
                          height="315"
                          :src="data.video"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerpolicy="strict-origin-when-cross-origin"
                          allowfullscreen
                        ></iframe>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        id="carouselExample"
                        class="carousel slide"
                        data-bs-ride="carousel"
                        data-bs-interval="3000"
                        style="background-color: rgba(0, 0, 0, 0.3)"
                      >
                        <div class="carousel-inner">
                          <div
                            class="carousel-item d-flex justify-content-center align-items-center"
                            v-for="(image, index) in data.story_images"
                            :class="{ active: index === 0 }"
                            :key="index"
                          >
                            <img
                              :src="$store.state.server + image.img"
                              class="d-block w-75"
                              alt="gallery image"
                            />
                          </div>
                        </div>
                        <button
                          class="carousel-control-prev"
                          type="button"
                          data-bs-target="#carouselExample"
                          data-bs-slide="prev"
                        >
                          <span
                            class="carousel-control-prev-icon"
                            aria-hidden="true"
                          ></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button
                          class="carousel-control-next"
                          type="button"
                          data-bs-target="#carouselExample"
                          data-bs-slide="next"
                        >
                          <span
                            class="carousel-control-next-icon"
                            aria-hidden="true"
                          ></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- ======= End Media Content ======= -->
                </div>
                <!-- End post content -->
              </article>
              <!-- End blog post -->
            </div>
          </div>
        </div>
      </section>
      <!-- End Blog Details Section -->
    </main>
    <!-- End #main -->
  </div>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";
import axios from "axios";
import store from "@/store";
import { Carousel } from "bootstrap";

export default {
  name: "story-details",
  components: {
    NavbarComponent,
  },
  data() {
    return {
      id: "",
      data: [],
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_story_id/" + this.id)
        .then((response) => {
          this.data = response.data;
          if (Object.keys(this.data.story_images).length > 0) {
            const carousel = document.querySelector("#carouselExample");
            if (carousel) {
              new Carousel(carousel, {
                interval: 3000,
                ride: "carousel",
              });
            }
          }
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compressDate(inputDate) {
      const date = new Date(inputDate);
      const options = { month: "short" };
      const month = new Intl.DateTimeFormat("en-US", options).format(date);
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month}, ${day} ${year}`;
    },
  },
  mounted() {
    let params = new URL(document.location.toString()).searchParams;
    this.id = params.get("id");
    this.getData();
  },
};
</script>

<style scoped>
.title-blog {
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
  color: var(--color-secondary);
}

.title-route {
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
}

.title-route a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.title-route a:hover {
  color: var(--color-primary);
}
</style>
